import { render } from "./UserProfileForm.vue?vue&type=template&id=9a698b38&scoped=true"
import script from "./UserProfileForm.vue?vue&type=script&lang=js"
export * from "./UserProfileForm.vue?vue&type=script&lang=js"

import "./UserProfileForm.vue?vue&type=style&index=0&id=9a698b38&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a698b38"]])

export default __exports__